import { DATA, C, FONT_HEAD, FONT_MONO } from "../data";

function SectionLabel({ num, title }) {
  return (
    <div style={{ marginBottom: "1rem", paddingLeft: "clamp(0px, 15vw, 4.5rem)" }}>
      <div style={{ fontFamily: FONT_MONO, fontSize: "0.72rem", color: C.accentBorder, letterSpacing: "4px", marginBottom: "0.6rem" }}>
        {num + " ───────────"}
      </div>
      <h2 style={{ fontFamily: FONT_HEAD, fontWeight: 800, fontSize: "clamp(1.3rem,4vw,2.6rem)", color: "#fff" }}>
        {title}
      </h2>
    </div>
  );
}

export default function Projects() {
  return (
    <div className="anim-fadeup" style={{ padding: "4rem clamp(1.5rem,5vw,4rem)", maxWidth: "900px", margin: "0 auto" }}>
      <SectionLabel num="03" title="Projects" />

      <div style={{ height: "1px", background: `linear-gradient(90deg, ${C.accentBorder}, transparent)`, marginBottom: "3rem", marginLeft: "clamp(0px, 15vw, 4.5rem)" }} />

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(270px,1fr))", gap: "1.5rem" }}>
        {DATA.projects.map(proj => (
          <div key={proj.title} className="card-lift" style={{
            background: C.card, border: `1px solid ${C.cardBorder}`,
            borderRadius: "10px", padding: "1.75rem",
            display: "flex", flexDirection: "column", gap: "1.1rem",
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "1.8rem" }}>{proj.icon}</span>
              <span style={{ fontFamily: FONT_MONO, color: C.faint, fontSize: "0.72rem" }}>{proj.year}</span>
            </div>
            <div>
              <h3 style={{ fontFamily: FONT_HEAD, fontWeight: 700, fontSize: "1rem", color: "#fff", marginBottom: "0.55rem" }}>
                {proj.title}
              </h3>
              <p style={{ fontFamily: FONT_MONO, color: C.muted, fontSize: "0.8rem", lineHeight: 1.8 }}>
                {proj.description}
              </p>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", marginTop: "auto" }}>
              {proj.tech.map(t => (
                <span key={t} style={{
                  background: C.violetDim, color: C.violet,
                  border: `1px solid ${C.violetBorder}`,
                  padding: "3px 9px", borderRadius: "4px",
                  fontSize: "0.7rem", fontFamily: FONT_MONO,
                }}>
                  {t}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
